import type { Merge } from "@scaleaq/sui-react/utility/types";
import clsx from "clsx";
import { Button } from "src/components";
import styles from "./Popover.item.module.scss";

export namespace PopoverItem {
    export type Props = Merge<Button.Props, {}>;
    export type ElementName = "button";
    export type ElementType = HTMLButtonElement;
}

export const PopoverItem = (componentProps: PopoverItem.Props) => {
    const { className, children, state, onClick, ...rest } = componentProps; 

    return (
        <Button className={clsx(styles["popover-item"], className)} state={state} onClick={onClick} {...rest}>
            {children}
        </Button>
    );
};